import Image from "next/image";
import React from "react";
import styles from "@/styles/desktop/Footer.module.scss";

type HeaderProps = {
  logoSrc: string;
  brandName: string;
  iconSrcs: string[];
  iconHrefs?: readonly string[];
};

const Header: React.FC<HeaderProps> = ({
  logoSrc,
  brandName,
  iconSrcs,
  iconHrefs,
}) => (
  <header className={styles.header}>
    <div className={styles.logoContainer}>
      <div className={styles.logoWrapper}>
        <Image
          width={400}
          height={400}
          loading="lazy"
          src={logoSrc}
          alt="Company logo"
          className={styles.logo}
        />
      </div>
      <div className={styles.brandName}>{brandName}</div>
    </div>
    <nav className={styles.socialNav}>
      {iconSrcs.map((src, index) => {
        const icon = (
          <Image
            width={400}
            height={400}
            loading="lazy"
            src={src}
            alt={`Navigation icon ${index + 1}`}
            className={styles.socialIcon}
          />
        );

        const href = iconHrefs?.[index];
        if (!href) {
          return <React.Fragment key={"iconsrc" + src + index}>{icon}</React.Fragment>;
        }

        return (
          <a
            key={"iconsrc" + src + index}
            href={href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={`Abrir rede social ${index + 1}`}
          >
            {icon}
          </a>
        );
      })}
    </nav>
  </header>
);

export default Header;
